module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_LinkReview.e6442afc.png";